<template>
  <div
    ref="vueCarouselSlide"
    :class="[
      'VueCarousel-slide',
      {
        'VueCarousel-slide-adjustableHeight': isAdjustableHeight,
        'VueCarousel-slide-adjust': adjust
      }
    ]"
  >
    <slot></slot>
  </div>
</template>

<script>
/**
 * Fork of @jambonn/vue-concise-carousel Slide: upstream used tabindex="-1" and role="tabpanel",
 * which does not match a carousel (not a tab UI). Inner favorite `<button>` tiles stay in tab order.
 */
import {
  ref,
  inject,
  nextTick,
  computed,
  onMounted,
  onBeforeUnmount
} from "vue"

export default {
  name: "FavoriteCarouselSlide",
  emits: ["slide-click"],
  props: {
    adjust: {
      type: Boolean,
      default: false
    }
  },
  setup(props, ctx) {
    const carousel = inject("carousel")

    const vueCarouselSlide = ref(null)

    const isAdjustableHeight = computed(() => {
      return carousel.adjustableHeight
    })

    const onTouchEnd = (e) => {
      const eventPosX =
        carousel.isTouch && e.changedTouches && e.changedTouches.length > 0
          ? e.changedTouches[0].clientX
          : e.clientX
      const deltaX = carousel.dragStartX.value - eventPosX
      if (
        carousel.minSwipeDistance === 0 ||
        Math.abs(deltaX) < carousel.minSwipeDistance
      ) {
        ctx.emit("slide-click", Object.assign({}, e.currentTarget.dataset))
      }
    }

    const onDragStart = (e) => e.preventDefault()

    onMounted(() => {
      nextTick(() => {
        const el = vueCarouselSlide.value
        if (!el) return
        el.addEventListener("dragstart", onDragStart)
        el.addEventListener(
          carousel.isTouch ? "touchend" : "mouseup",
          onTouchEnd,
          true
        )
      })
    })
    onBeforeUnmount(() => {
      const el = vueCarouselSlide.value
      if (!el) return
      el.removeEventListener("dragstart", onDragStart)
      el.removeEventListener(
        carousel.isTouch ? "touchend" : "mouseup",
        onTouchEnd,
        true
      )
    })

    return {
      vueCarouselSlide,
      isAdjustableHeight
    }
  }
}
</script>
